import { render, staticRenderFns } from "./reportsComponent.vue?vue&type=template&id=563013a4&scoped=true"
import script from "./reportsComponent.vue?vue&type=script&lang=js"
export * from "./reportsComponent.vue?vue&type=script&lang=js"
import style0 from "./reportsComponent.vue?vue&type=style&index=0&id=563013a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563013a4",
  null
  
)

export default component.exports